import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import lwsLogo from "../assets/lws-logo-dark.svg";
import { userLoggedOut } from "../features/auth/authSlice";

const Navbar = () => {
    const { user } = useSelector((state) => state.auth) || {};
    const dispatch = useDispatch();

    const handleLogout = () => {
        dispatch(userLoggedOut());
        localStorage.clear();
    };

    return (
        <nav className="border-general sticky top-0 z-40 border-b bg-violet-700 transition-colors">
            <div className="max-w-7xl mx-auto">
                <div className="flex justify-between h-16 items-center">
                    <Link to="/">
                        <img className="h-10" src={lwsLogo} alt="lws logo" />
                    </Link>
                    <ul>
                        <li className="text-white flex items-center">
                            <span className="flex items-center mr-10">
                                <span className="material-symbols-outlined mr-1">
                                    account_circle
                                </span>
                                {user?.name}
                            </span>
                            <span
                                className="cursor-pointer flex items-center"
                                onClick={handleLogout}
                            >
                                <span className="material-symbols-outlined mr-1">
                                    logout
                                </span>
                                Logout
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
